import { render, staticRenderFns } from "./ContractorEmployeeCard.vue?vue&type=template&id=fdb0b0be"
import script from "./ContractorEmployeeCard.vue?vue&type=script&lang=ts"
export * from "./ContractorEmployeeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdb0b0be')) {
      api.createRecord('fdb0b0be', component.options)
    } else {
      api.reload('fdb0b0be', component.options)
    }
    module.hot.accept("./ContractorEmployeeCard.vue?vue&type=template&id=fdb0b0be", function () {
      api.rerender('fdb0b0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorEmployeeCard.vue"
export default component.exports